import type { IconAliases } from "vuetify";
import {
  User,
  Users,
  Clock,
  Calendar,
  CalendarOff,
  Settings,
  RefreshCw,
  Store,
  Shield,
  EyeOff,
  Eye,
  Camera,
  Search,
  LogOut,
  ExternalLink,
  Briefcase,
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  Copy,
  FileText,
  SquareArrowOutUpRight,
  Phone,
  Mail,
  CircleUser,
  CircleCheck,
  MoveLeft,
  Image,
  MapPin,
  Building2,
  Lock,
  House,
  ServerCrash,
  EllipsisVertical,
  FileSpreadsheet,
  CircleX,
  Sparkles,
  Star,
  StarOff,
  CreditCard,
  Download,
} from "@lucide/vue";

export const icons: Partial<IconAliases> = {
  user: User,
  users: Users,
  clock: Clock,
  copy: Copy,
  calendar: Calendar,
  absence: CalendarOff,
  settings: Settings,
  sync: RefreshCw,
  store: Store,
  admin: Shield,
  eyeOff: EyeOff,
  eye: Eye,
  camera: Camera,
  search: Search,
  logout: LogOut,
  link: ExternalLink,
  briefcase: Briefcase,
  formatBold: Bold,
  formatItalic: Italic,
  formatUnderline: Underline,
  formatListBullet: List,
  formatListNumbered: ListOrdered,
  externLink: SquareArrowOutUpRight,
  file: FileText,
  phone: Phone,
  email: Mail,
  circleUser: CircleUser,
  confirmation: CircleCheck,
  back: MoveLeft,
  image: Image,
  location: MapPin,
  company: Building2,
  lock: Lock,
  dashboard: House,
  serverCrash: ServerCrash,
  ellipsisVertical: EllipsisVertical,
  spreadsheet: FileSpreadsheet,
  denied: CircleX,
  onboarding: Sparkles,
  present: Star,
  absent: StarOff,
  payment: CreditCard,
  download: Download,
} as unknown as Partial<IconAliases>;
